define('controllers/aplpromote/cloud-folder-promote-list.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('cFPromoteListCtrl', ['$scope', '$state', 'UserInfo', '$stateParams', 'auiDialog', 'InAppNew', '$filter',
        function ($scope, $state, UserInfo, $stateParams, auiDialog, InAppNew, $filter) {

            var QUERY_ALL_STATUS = ['CREATIVE PENDING', 'AUDIT PENDING', 'REJECTED', 'RUN', 'CANCELED', 'DONE'];

            $scope.Model = {
                appList: []
            };

            //视图中绑定方法
            $scope.Method = {
                cancelCFPTask: cancelCFPTask,
                deleteCFPTask: deleteCFPTask,
                modifyCFPTask: modifyCFPTask,
                createCFPTask: createCFPTask
            };

            //应用推广任务列表视图绑定
            $scope.TaskListModel = {
                constant: {
                    cfpTaskState: mainCons.appConstant.cfpTaskState,
                    ppsAdvertiser:sysUrlCfg.ppsAdvertiser
                },
                taskCfpList: null,//用于驱动列表显示
                tableHeader: {
                    "cfpTaskState": {
                        id: "cfpTaskState",
                        name: "状态",
                        data: mainCons.appConstant.cfpTaskStateComBox,
                        filterMethod: queryCfpTaskList,
                        queryMethod: queryCfpTaskList
                    }
                },
                query: {
                    pagination: {
                        currentPage: 1,// 当前页
                        itemsPerPage: 10,// 默认每页个数
                        itemsPerPageBackUp: 10,
                        totalCount: 0,
                        noItems: "No products",
                        pagesLength: 5,// 显示的页码数量,
                        onChange: queryCfpTaskList
                    },
                    tableHeader: {
                        cfpTaskState: QUERY_ALL_STATUS
                    }
                }
            };

            //初始化函数
            function init() {
                UserInfo.promise().then(function (userInfo) {
                    var isOK = false;
                    var params = {
                        userEmail: userInfo.contactEmail,
                        loginName: userInfo.loginName
                    };
                    //注册精准服务
                    InAppNew.checkLogin(params).then(function (data) {
                        isOK = data && data.retCode == 0;
                    }).catch().finally(function () {
                        if (isOK) {
                            //查询列表
                            queryCfpTaskList();
                        } else {
                            auiDialog.fail("注册精准服务失败。");
                        }
                    });
                });
            }

            //查询任务列表
            function queryCfpTaskList() {
                var status = $scope.TaskListModel.query.tableHeader.cfpTaskState.join(',').replace(',all', '');
                //什么也不勾选，查询所有（不包括：已删除）
                if (!status) {
                    $scope.TaskListModel.taskCfpList = [];
                    $scope.TaskListModel.query.pagination.totalCount = 0;
                    return false;
                }

                InAppNew.getCfpTaskList({
                    status: status,
                    pageNum: $scope.TaskListModel.query.pagination.currentPage,
                    pageSize: $scope.TaskListModel.query.pagination.itemsPerPage
                }).then(function (data) {
                    if (data && data.retCode == 0) {
                        $scope.TaskListModel.query.pagination.totalCount = data.total;
                        $scope.TaskListModel.taskCfpList = data.taskInfoList;

                    } else {
                        showErrorDialog(data.retCode, '获取任务列表失败。');
                    }
                }).catch(function (data) {
                    if (data && data.NSP_STATUS) {
                        auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                    } else if (data && data.retCode) {
                        showErrorDialog(data.retCode, '获取任务列表失败。');
                    }
                });
            }

            //修改
            function modifyCFPTask(CFPTask) {
                $state.go('aplPromoteCFAdd', {taskId: CFPTask.taskId, serviceItem: 51}, {reload: true});
            	
            }

            //创建
            function createCFPTask() {
                $state.go('aplPromoteCFAdd', {taskId: 0, serviceItem: 51}, {reload: true});
            }

            //取消任务
            function cancelCFPTask(CFPTask) {
                // 参数
                var paramInf = {
                    taskId: CFPTask.taskId
                };
                auiDialog.confirm('确认取消任务？', function () {
                    InAppNew.cancelCfpTask(paramInf).then(function (data) {
                        if (data && data.retCode == 0) {
                            auiDialog.success('取消任务成功。', queryCfpTaskList);
                        } else {
                            showErrorDialog(data.retCode, '取消任务失败。');
                        }

                    }).catch(function (data) {
                        if (data && data.NSP_STATUS) {
                            auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                        } else if (data && data.retCode) {
                            showErrorDialog(data.retCode, '取消任务失败。');
                        }
                    });
                });

            }

            //删除任务
            function deleteCFPTask(CFPTask) {
                // 参数
                var paramInf = {
                    taskId: CFPTask.taskId
                };
                auiDialog.confirm('确认删除任务？', function () {
                    InAppNew.deleteCfpTask(paramInf).then(function (data) {
                        if (data && data.retCode == 0) {
                            auiDialog.successAndMark('删除任务成功。', queryCfpTaskList, {isOnShelf: '4|51'});
                        } else {
                            showErrorDialog(data.retCode, '删除任务失败。');
                        }

                    }).catch(function (data) {
                        if (data && data.NSP_STATUS) {
                            auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                        } else if (data && data.retCode) {
                            showErrorDialog(data.retCode, '删除任务失败。');
                        }
                    });
                });
            }

            init();

            function showErrorDialog(code, infoDefault) {
                auiDialog.fail({
                    403: '很抱歉，您的帐号已失效。',
                    410: '很抱歉，您的帐号已被管理员冻结。',
                    720: '鲸鸿动能广告投放基金余额不足。',
                    1000000006: '联盟登录优易点失败，请稍候重试。'
                }[code] || infoDefault || '请求失败，请稍候重试。');
            }

            function isEmptyObj(obj) {
                for (var key in obj) {
                    return false;
                }
                return true;
            }

            // 有时候弹出多个错误框
            setInterval(function () {
                if (angular.element("#cfpTask").length > 0 && angular.element(".dialog-cover").length > 1) {
                    angular.element(".icon-close").eq(0).click();
                }
            }, 10);
        }
    ]);
})
;

